import React, { useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function AIChatView({ aiChat }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id="tooltip-top">View</Tooltip>}
      >
        <img
          src="/images/png/view.png"
          onClick={handleShow}
          className="pointer"
          width={35}
          alt="action"
        />
      </OverlayTrigger>

      {show && (
        <Modal
          show={show}
          className="custom-modal"
          size="lg"
          centered
          scrollable
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>View AI Chat</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row g-3">
              <div className="col-12 col-lg-6">
                <Form.Label className="mb-0">Name</Form.Label>
                <p>
                  {aiChat.user?.firstName ? aiChat.user?.firstName : ""}
                  {aiChat.user?.lastName ? " " + aiChat.user?.lastName : ""}
                </p>
              </div>
              <div className="col-12 col-lg-6">
                <Form.Label className="mb-0">Email</Form.Label>
                <p>{aiChat.user?.email ? aiChat.user?.email : "-"}</p>
              </div>
              <div className="col-12">
                <Form.Label className="mb-0">Prompt</Form.Label>
                <p>{aiChat.prompt ? aiChat.prompt : "-"}</p>
              </div>

              <div className="col-12">
                <Form.Label className="mb-0">Response</Form.Label>
                <p
                  dangerouslySetInnerHTML={{
                    __html: aiChat.response ? aiChat.response : "",
                  }}
                ></p>
              </div>

              <div className="col-12 col-lg-6">
                <Form.Label className="mb-0">Created Date</Form.Label>
                <p>
                  {aiChat.createdAt
                    ? new Date(aiChat.createdAt).toISOString().split("T")[0]
                    : "-"}
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default AIChatView;
